import { useTranslation } from "react-i18next";

import type { IAppointmentDataStatusProps } from "@components/molecules/appointmentStatus";
import classes from "@components/organisms/appointmentCard/components/appointmentStatusPlace/styles.module.scss";
import { Typography } from "@components/atoms/typography";
import { addColon } from "@utils";
import { AppointmentDataStatus } from "@components/molecules/appointmentStatus/appointmentDataStatus";

export function AppointmentDataStatusPlace(props: IAppointmentDataStatusProps) {
  const { t } = useTranslation("form");

  return (
    <div className={classes.appointmentStatus}>
      <Typography fontFamily={"dana"}>
        {addColon(t("followup-status.title"))}
      </Typography>
      <AppointmentDataStatus {...props} />
    </div>
  );
}
